import { useEffect, useState } from "react";

// Forces a re-render every second (so live countdowns update) and whenever
// another tab/window on this browser freezes a sync button (so it freezes here instantly too).
const useSyncFreezeTick = () => {
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key && e.key.startsWith("sync_freeze_")) {
        setTick((t) => t + 1);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
};

export default useSyncFreezeTick;
